import React from "react";
import { Row, Col } from "reactstrap";
import styles from "../../../src/assets/scss/common/viewSkeleton.module.scss";

/* ---------- Props ---------- */

interface ViewSkeletonProps {
  sections?: number;
  fieldsPerSection?: number;
  columns?: number[];
  showHeader?: boolean;
  showBadge?: boolean;
}

/* ---------- Component ---------- */

const ViewSkeleton: React.FC<ViewSkeletonProps> = ({
  sections = 3,
  fieldsPerSection = 3,
  columns = [3, 3, 3],
  showHeader = true,
  showBadge = false,
}) => {
  const renderSkeletonField = (count: number) =>
    Array.from({ length: count }).map((_, i) => (
      <Col lg="3" md="6" sm="12" key={i}>
        <div className={styles.reviewItem}>
          <div className={`${styles.skeletonLine} w-50 mb-1`} />
          <div className={`${styles.skeletonLine} w-75`} />
        </div>
      </Col>
    ));

  return (
    <>
      {Array.from({ length: sections }).map((_, sectionIndex) => (
        <div
          className={`${styles.reviewBox} mb-3`}
          key={sectionIndex}
        >
          {/* Header Skeleton */}
          {showHeader && (
            <div className="mb-2 pb-2 border-bottom d-flex justify-content-between align-items-center">
              <div className={`${styles.skeletonLine} w-25`} />
              {showBadge && <div className={styles.skeletonBadge} />}
            </div>
          )}

          {/* Field Skeletons */}
          <Row className="g-2">
            {renderSkeletonField(fieldsPerSection)}
          </Row>
        </div>
      ))}
    </>
  );
};

export default ViewSkeleton;
